import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  public $durableFunctionEnvironment: BehaviorSubject<string>;
  public $datalakeEnvironment: BehaviorSubject<string>;

  constructor(private configService: ConfigService){
 
    this.$durableFunctionEnvironment = new BehaviorSubject<string>("");
    this.$datalakeEnvironment = new BehaviorSubject("");

    this.configService.$configuration.subscribe(config => {
      if(config != null){
        let env = config.environment != null ? config.environment : "";
        this.setDurableFunctionEnvironment(env);
      }
    });
  }

  public setDurableFunctionEnvironment(environment: string) {
    switch(environment) {
      case "PROD":
        this.$durableFunctionEnvironment.next(environment);
        break;
      case "TEST":
        this.$durableFunctionEnvironment.next(environment);
        break;
      case "DEV":
        this.$durableFunctionEnvironment.next(environment);
        break;
    }
  }
}
